export default __webpack_public_path__ + "static/fine_art_preview-fbf803d79dd30ecf8651886f74830714.mp4";